import theme from '../../../theme';
import { SxStyles } from '../../../types';
import { getResponsiveSize } from '../../../utils';

export const buttonStyles: SxStyles = {
  button: {
    py: 1.5,
    px: 2,
    height: 46,
    fontSize: '1.97vmin',
    lineHeight: '22px',
    textTransform: 'none',
    borderRadius: theme.palette?.propVars?.borderRadius,
    fontWeight: theme.palette?.propVars?.semiBoldFontWeight,
    backgroundSize: '200%',
    backgroundPosition: ' right bottom',
    boxShadow: 'none',
    '&.Mui-disabled': {
      opacity: 0.5,
    },
    '&:hover': {
      boxShadow: 'none',
    },
    '&.primaryBtn': {
      backgroundImage: `linear-gradient(to left, ${theme.palette?.myPrimary?.lightBlue100} 50%, ${theme.palette?.myPrimary?.darkBlue100} 50%)`,
      color: theme.palette?.myPrimary?.white,
      '&:hover': {
        backgroundPosition: 'left bottom',
      },
      '&:active': {
        boxShadow: 'none',
      },
      '&.Mui-disabled': {
        background: theme.palette?.myPrimary?.lightBlue100,
      },
    },
    '&.secondaryBtn': {
      backgroundImage: `linear-gradient(to left, transparent 50%, ${theme.palette.myPrimary?.lightBlue40} 50%)`,
      border: `1px solid ${theme.palette.myPrimary?.lightBlue100}`,
      color: theme.palette.myPrimary?.lightBlue100,
      '&:hover': {
        backgroundPosition: 'left bottom',
      },
      '&:active': {
        color: theme.palette.myPrimary?.lightBlue100,
      },
      '&.Mui-disabled': {
        backgroundColor: 'transparent',
      },
    },
    '&.inputBtn': {
      backgroundColor: theme.palette.myPrimary?.lightBlue100,
      backgroundImage: `linear-gradient(to left, ${theme.palette.myPrimary?.lightBlue70} 50%, ${theme.palette.myPrimary?.lightBlue100} 50%)`,
      color: theme.palette.myPrimary?.white,
      '&:hover': {
        backgroundPosition: 'left bottom',
      },
      '&.Mui-disabled': {
        background: theme.palette.myPrimary?.lightBlue100,
      },
    },
    '&.modalPrimaryBtn': {
      backgroundColor: theme.palette.myPrimary?.lightBlue70,
      color: theme.palette.myPrimary?.white,
      width: getResponsiveSize(85.1),
      minWidth: getResponsiveSize(85.1),
      height: getResponsiveSize(35),
      borderRadius: getResponsiveSize(4),
      fontFamily: theme.typography.mainFontFamily,
      fontSize: theme.typography.fs14,
      lineHeight: 2.2,
      p: 0,
      '&:hover': {
        backgroundColor: theme.palette.myPrimary?.lightBlue70,
        opacity: 0.9,
      },
      '&.MuiButton-fullWidth': {
        width: '100%',
        minWidth: '100%',
      },
    },
    '&.modalSecondaryBtn': {
      borderColor: theme.palette.myPrimary?.lightBlue70,
      borderStyle: 'solid',
      borderWidth: getResponsiveSize(1),
      color: theme.palette.myPrimary?.lightBlue70,
      width: getResponsiveSize(85.1),
      minWidth: getResponsiveSize(85.1),
      height: getResponsiveSize(36),
      borderRadius: getResponsiveSize(4),
      fontFamily: theme.typography.mainFontFamily,
      fontSize: theme.typography.fs14,
      lineHeight: 2.2,
      p: 0,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: 'transparent',
        borderColor: theme.palette.myPrimary?.lightBlue70,
        opacity: 0.9,
      },
      '&.MuiButton-fullWidth': {
        width: '100%',
        minWidth: '100%',
      },
    },
    '&.modalTextBtn': {
      minWidth: getResponsiveSize(45.1),
      height: getResponsiveSize(30),
      fontFamily: theme.typography.mainFontFamily,
      fontSize: theme.typography.fs14,
      lineHeight: getResponsiveSize(20),
      p: 0,
      color: theme.palette.myPrimary?.lightBlue70,
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
        color: theme.palette.myPrimary?.lightBlue100,
        boxShadow: 'none',
      },
      '&:active': {
        backgroundColor: theme.palette.myPrimary?.lightBlue40,
      },
    },
  },
};
